"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.communications_search.name': 'Búsqueda de Comunicaciones',
    'tools.communications_search.description': 'Buscar y recorrer datos de comunicación incluyendo resúmenes de grupos, registros de seguimiento y configuraciones por número de teléfono',
};
